export enum ConnectionOutStatus {
  NONE = 0,
  PENDING = 1,
  DONE = 2,
  ERROR = 3
}
